<template>
  <div class="ProductImgSlide">
    <div class="menu flx">
      <span
        class="tabIcon"
        style="box-shadow: none; background: none"
        v-if="!$route.path.includes('/product-deal')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#505050" fill-rule="evenodd">
            <path
              fill="#505050"
              fill-rule="nonzero"
              stroke="#505050"
              stroke-width="0.05"
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              fill="#505050"
              fill-rule="nonzero"
              stroke="#505050"
              stroke-width="0.05"
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
      </span>
      <div>
        <!-- <span
          class="tabIcon"
          @click="
            shareFunc(
              details.shareMessageUrl,
              details.itemMediaDTOList[0].original,
              details.sellerItemRelationshipId
            )
          "
          v-if="$cookie.get('version-code')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 30 28"
          >
            <path
              fill="green"
              stroke="green"
              d="M25.2 19.2c-1.371.003-2.655.675-3.438 1.8L9 14.268c.043-.333.043-.67 0-1.002l12.72-6.714c1.232 1.826 3.666 2.39 5.575 1.292 1.91-1.098 2.647-3.485 1.688-5.469C28.025.392 25.696-.514 23.65.3c-2.047.815-3.117 3.072-2.451 5.172l-12.57 6.6C7.83 10.252 5.865 9.24 3.92 9.647 1.975 10.055.581 11.77.581 13.758c0 1.988 1.394 3.703 3.339 4.11 1.945.408 3.91-.604 4.708-2.424l12.564 6.6c-.588 1.725.003 3.632 1.463 4.722 1.46 1.09 3.457 1.114 4.943.06 1.486-1.055 2.122-2.948 1.576-4.686-.547-1.738-2.152-2.926-3.974-2.94zm0-18c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zM4.8 16.8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879zm20.4 9.6c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
            />
          </svg>
        </span> -->
        <!-- <router-link :to="{ path: '/cart-check-out'}" tag="span" class="tabIcon" :class="{'added': productAddedAction}"> -->
        <!-- <span
          class="tabIcon tab-cart"
          :class="{'added' : productAddedAction}"
          @click="goToCart()"
          v-if="$cookie.get('JWT-TOKEN')"
        >
          <span
            class="one-cart-size"
            v-if="cartSize>0"
          >{{cartSize}}</span>
          <span class="add-no">{{cartSize}}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="22"
            viewBox="0 0 21 26"
          >
            <g>
              <path
                fill="#505050"
                d="M20.986 21.44L19.804 6.81c-.074-.943-.886-1.681-1.849-1.681H15.62v-.103C15.62 2.255 13.323 0 10.5 0S5.381 2.255 5.381 5.026v.103H3.045c-.963 0-1.775.738-1.848 1.679L.014 21.443c-.092 1.172.322 2.338 1.135 3.2C1.963 25.505 3.116 26 4.313 26h12.374c1.197 0 2.35-.495 3.164-1.357.813-.862 1.227-2.028 1.135-3.202zM6.932 5.027c0-1.932 1.6-3.503 3.568-3.503 1.967 0 3.568 1.571 3.568 3.503v.103H6.932v-.103zm11.78 18.582c-.528.56-1.247.87-2.025.87H4.313c-.778 0-1.497-.31-2.025-.87-.529-.56-.787-1.288-.728-2.047L2.743 6.926c.012-.154.145-.274.302-.274h2.336v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h7.136v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h2.336c.157 0 .29.12.302.276L19.44 21.56c.06.761-.199 1.49-.727 2.05z"
              />
            </g>
          </svg>
        </span> -->
        <!-- </router-link > -->

        <!-- <span
          class="tabIcon"
          :class="{'active' : isBookMark == false}"
          @click="bookMark(details.saleReferenceID,isBookMark)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17">
            <path
              fill="#505050"
              fill-rule="evenodd"
              d="M11.433 14.328V2.52a.829.829 0 0 0-.816-.84H2.45a.829.829 0 0 0-.817.84v11.808l4.426-3.252a.798.798 0 0 1 .949 0l4.425 3.252zm-4.9-1.536l-5.242 3.852c-.54.397-1.291 0-1.291-.684V2.52C0 1.128 1.097 0 2.45 0h8.167c1.353 0 2.45 1.128 2.45 2.52v13.44c0 .683-.751 1.08-1.292.684l-5.242-3.852z"
            />
          </svg>
        </span> -->
      </div>
    </div>
    <div
      v-if="details.itemMediaDTOList && details.itemMediaDTOList.length > 0"
      class="swiper-container product-slide"
    >
      <div
        class="swiper-wrapper"
        @click="openProductGallery = !openProductGallery"
      >
        <div
          class="swiper-slide"
          v-if="
            details.itemVideoDTOList &&
            details.itemVideoDTOList.length &&
            details.itemVideoDTOList[0].original &&
            getImageURL
          "
          id="0"
        >
          <video
            id="itemVideo"
            poster="../../assets/images/mall91_logo.jpg"
            :src="videoSrc"
            autoplay
            controls
            :muted="videoMute"
            width="100%"
            height="100%"
          ></video>
        </div>
        <div
          :id="isVideoIndex(index)"
          class="swiper-slide"
          v-for="(productImage, index) in details.itemMediaDTOList"
          :key="index"
        >
          <!-- <span v-lazyload class="image__wrapper" v-if="productImage.original">
            <ImageSpinner class="image__spinner" />
            <img class="image__item" :data-url="productImage.original" alt="random image" />
          </span> -->
          <span class="image__wrapper" v-if="productImage.original">
            <!-- <ImageSpinner class="image__spinner" /> -->
            <img
              class="image__item"
              :src="productImage.original"
              alt="random image"
            />
          </span>
        </div>
      </div>
      <div
        class="swiper-pagination"
        v-if="details.itemMediaDTOList.length > 1"
      ></div>
    </div>
    <div class="thumbnail_image" v-else>
      <img
        class="image__item"
        src="../../assets/images/watermark1.jpg"
        alt="random image"
      />
    </div>
    <!-- <div class="champion_list flx"> -->
    <!-- <div class="credit_list" style="width:100%">
        <div class="swiper-container latstcredit-slide">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(credit,index) in latestCreditList" :key="index">
              <div class="upper_part">
                <div class="credit_detail">
                  <p v-if="credit.winningAmount > 0" class="text">
                    <span
                      v-html="$t('boughtOnly',{personName:credit.userName.substr(0, 8),personLocation:credit.userCity.substr(0, 10)})"
                    ></span>
                  </p>
                  <p v-if="credit.winningBCoin > 0" class="text">
                    <span
                      v-html="$t('boughtOnly',{personName:credit.userName.substr(0, 8),personLocation:credit.userCity.substr(0, 10)})"
                    ></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    <!-- <div class="credit_list">
        <div class="credit_detail">
          <p
            class="text"
            v-html="$t('boughtOnlyFromCity',{cityName:details.cityName,peopleCount:details.peopleBought})"
          ></p>
        </div>
      </div> -->
    <!-- </div> -->

    <div
      class="prodgallery_wrap"
      v-if="openProductGallery == true && details.itemMediaDTOList"
    >
      <div class="product_Gallery">
        <span
          class="close_prodgallery"
          @click="openProductGallery = !openProductGallery"
        >
          <i class="material-icons">close</i>
        </span>
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-if="
                details.itemVideoDTOList &&
                details.itemVideoDTOList.length &&
                details.itemVideoDTOList[0].original &&
                getImageURL
              "
              id="0"
            >
              <video
                id="itemVideo"
                poster="../../assets/images/mall91_logo.jpg"
                :src="videoSrc"
                autoplay
                controls
                :muted="videoMuteLarge"
                width="100%"
                height="100%"
              ></video>
            </div>
            <div
              :id="isVideoIndex(index)"
              class="swiper-slide"
              v-for="(productImage, index) in details.itemMediaDTOList"
              :key="index"
            >
              <!-- <div v-lazyload class="img_wrapper spinner_wrapper" v-if="productImage.original">
                <ImageSpinner class="image_spinner" />
                <img :data-url="productImage.original" alt />
              </div> -->
              <div
                class="img_wrapper spinner_wrapper"
                v-if="productImage.original"
              >
                <!-- <ImageSpinner class="image_spinner" /> -->
                <img :src="productImage.original" alt />
              </div>
            </div>
          </div>
          <div class="swiper-button-next">
            <i class="material-icons">arrow_forward_ios</i>
          </div>
          <div class="swiper-button-prev">
            <i class="material-icons">arrow_back_ios</i>
          </div>
        </div>
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-if="
                details.itemVideoDTOList &&
                details.itemVideoDTOList.length &&
                details.itemVideoDTOList[0].original &&
                getImageURL
              "
              id="0"
            >
              <video
                id="itemVideo"
                poster="../../assets/images/mall91_logo.jpg"
                :src="videoSrc"
                controls
                width="100%"
                height="100%"
              ></video>
            </div>
            <div
              :id="isVideoIndex(index)"
              class="swiper-slide"
              v-for="(productImage, index) in details.itemMediaDTOList"
              :key="index"
            >
              <!-- <div class="img_wrapper spinner_wrapper" v-if="productImage.original" v-lazyload>
                <ImageSpinner class="image_spinner" />
                <img :data-url="productImage.original" alt />
              </div> -->
              <div
                class="img_wrapper spinner_wrapper"
                v-if="productImage.original"
              >
                <!-- <ImageSpinner class="image_spinner" /> -->
                <img :src="productImage.original" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import ImageSpinner from "../Common/ImageSpinner";
import Swiper from "swiper";
import "../../assets/css/swiper-slider.css";
import { mapGetters } from "vuex";
export default {
  name: "ImageSlider",
  components: { ImageSpinner },
  props: {
    dataValue: {
      required: true,
      type: Object,
    },
    viewerCount: {
      type: String,
    },
    productAddedAction: {
      type: Boolean,
    },
    productAdded: {
      type: Number,
    },
  },
  watch: {
    productAdded(newCount, oldCount) {
      console.log(`We have ${newCount} fruits now, yay!`);
    },
  },
  data() {
    return {
      details: {},
      isBookMark: true,
      viewCount: null,
      getImageURL: false,
      videoSrc: "",
      dynamicPagination: false,
      openProductGallery: false,
      latestCreditList: [],
      showAdButton: false,
      cartCount: 0,
      videoMute: false,
      videoElement: null,
      videoMuteLarge: false,
    };
  },
  computed: {
    ...mapGetters(["cartSize"]),
  },

  methods: {
    goToCart() {
      // if(this.$route.query.source){
      //   this.$router.push('/cart-check-out?source=' + this.$route.query.source)
      // }else{
      //   this.$router.push('/cart-check-out?source=LOCAL_HOME')
      // }
      if (this.$cookie.get("JWT-TOKEN")) {
        if (this.$route.query.shopid) {
          this.$router.push(
            "/cart-check-out" + "?shopid=" + this.$route.query.shopid
          );
        } else {
          this.$router.push("/cart-check-out");
        }
      } else {
        this.$emit("notLoggedInUser");
      }
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },

    shareFunc(shareMessage, shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        try {
          JSBridgePlugin.fireEvents("Detail_Page_Product_Shared");
        } catch (err) {
          console.log(err);
        }
        this.loading = true;
        ApiCaller(
          constant.LOCAL_SHOP_URL,
          `get-share-details/${saleReferenceID}?type=ITEM`,
          "get"
        )
          .then((data) => {
            this.shareLinkData = data.data;
            this.loading = false;
            shareMessage = data.data.shareMessage;
            const obj = {
              message: shareMessage,
              imageUrl: shareImage,
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + shareMessage);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },

    isVideoIndex(videoIndex) {
      if (
        this.details.itemVideoDTOList &&
        this.details.itemVideoDTOList.length
      ) {
        videoIndex = videoIndex + 1;
      }
    },
    bookMark(productId, isBookMark) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        try {
          if (this.isBookMark) {
            this.isBookMark = false;
          } else {
            this.isBookMark = true;
          }
          JSBridgePlugin.bookmarkProduct(Number(productId), isBookMark);
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
    getLatestCredit() {
      ApiCaller(
        constant.PAYBOARD_URL,
        "commons/fetchLatestCreditTransactions",
        "get"
      ).then((data) => {
        if (data.data) {
          this.latestCreditList = data.data.slice(0, 20);
          this.$nextTick(() => {
            var swiper = new Swiper(".latstcredit-slide", {
              loop: true,
              spaceBetween: 30,
              autoHeight: true,
              effect: "fade",
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
            });
          });
        }
      });
    },
  },
  watch: {
    viewerCount() {
      this.viewCount = this.viewerCount;
    },
    dataValue() {
      this.details = this.dataValue;
      if (
        this.details.itemMediaDTOList &&
        this.details.itemMediaDTOList.length > 5
      ) {
        this.dynamicPagination = true;
      }
      this.$nextTick(() => {
        var swiper = new Swiper(".product-slide", {
          loop: false,
          spaceBetween: 10,
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination",
            dynamicBullets: this.dynamicPagination,
            clickable: true,
          },
          on: {
            slideChange: () => {
              let index_currentSlide = swiper.realIndex;
              if (index_currentSlide != 0) {
                this.videoMute = true;
              } else {
                this.videoMute = false;
              }
            },
          },
        });
      });
      if (
        this.details &&
        this.details.itemVideoDTOList &&
        this.details.itemVideoDTOList[0] &&
        this.details.itemVideoDTOList[0].original
      ) {
        this.videoSrc = this.details.itemVideoDTOList[0].original;
        this.getImageURL = true;
      }
    },
    openProductGallery: function (val) {
      if (val == true) {
        this.$nextTick(() => {
          var galleryThumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
          });
          var galleryTop = new Swiper(".gallery-top", {
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            thumbs: {
              swiper: galleryThumbs,
            },
            on: {
              slideChange: () => {
                let index_currentSlide = galleryTop.realIndex;
                if (index_currentSlide != 0) {
                  this.videoMuteLarge = true;
                } else {
                  this.videoMuteLarge = false;
                }
              },
            },
          });
        });
      }
    },
  },
  mounted() {
    this.getLatestCredit();
    this.details = this.dataValue;
    if (
      this.details.itemMediaDTOList &&
      this.details.itemMediaDTOList.length > 5
    ) {
      this.dynamicPagination = true;
    }
    this.$nextTick(() => {
      var swiper = new Swiper(".product-slide", {
        loop: false,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: this.dynamicPagination,
          clickable: true,
        },
        on: {
          slideChange: () => {
            let index_currentSlide = swiper.realIndex;
            if (index_currentSlide != 0) {
              this.videoMute = true;
            } else {
              this.videoMute = false;
            }
          },
        },
      });
    });

    if (
      this.details &&
      this.details.itemVideoDTOList &&
      this.details.itemVideoDTOList[0] &&
      this.details.itemVideoDTOList[0].original
    ) {
      this.getImageURL = true;
      this.videoSrc = this.details.itemVideoDTOList[0].original;
    }
    this.viewCount = this.viewerCount;
  },
};
</script>
<style lang="scss" scoped>
.thumbnail_image {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100px;
    height: 100px;
  }
}
</style>
